import PropTypes from "prop-types";
import { Paragraph2 } from "../../../components";
import { CampaignsCounterContainer } from "./styled";

const CampaignsCounter = ({ activeCampaigns, maxActiveCampaigns, loading }) => {
  return (
    <CampaignsCounterContainer>
      {!loading && (
        <Paragraph2>
          {activeCampaigns}/{maxActiveCampaigns}
        </Paragraph2>
      )}
    </CampaignsCounterContainer>
  );
};

CampaignsCounter.propTypes = {
  activeCampaigns: PropTypes.number.isRequired,
  maxActiveCampaigns: PropTypes.number.isRequired,
  loading: PropTypes.bool
};

export default CampaignsCounter;
